import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ee549c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "message-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "提示", -1))
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = { class: "bind-code-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "提示", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*绑定邀请码后无法更换，请认真核对", -1))

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import { useRoute, useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { bindInvitationCode } from '@/apis/old-brings-new'
import { useCommonShare } from '@/compositions/activity/index'
import { showNormalToast, showToastLoading } from '@/utils/tools'
import Header from '@/components/Header.vue'
import CheckBindSn from './components/check-bind-sn.vue'
import InputWrapItem from './components/input-wrap-item.vue'
import ActivityDialog from './components/activity-dialog.vue'
import ActivityIntroduceImage from './components/activity-introduce-image.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'new-user',
  setup(__props) {

const { setMiniProgramShareInfo } = useCommonShare()
const store = useStore()
const tipsDialogShow = ref(false)
const showCheckBindSn = ref(false)
const code = ref('')
const bindDialogShow = ref(false)
const unJoinMessage = '您不满足新用户参与条件，具体条件可查看活动规则，感谢您的关注。'
const tipsContent = ref(unJoinMessage)
const isNewUser = ref(store?.state?.OldBringsNew?.isNewUser || false)
const $route = useRoute()
const $router = useRouter()
const inviteCode = $route.query.code as string

const bindedCode = computed(() => {
  return store?.state?.OldBringsNew?.bindInviteCode || ''
})
function startBindHandle() {
  if (bindedCode.value) {
    showCheckBindSn.value = true
    return
  }
  if (!isNewUser.value) {
    tipsDialogShow.value = true
    return
  }
  bindDialogShow.value = true
}

async function initActivityUserInfo() {
  if (!isNewUser.value) {
    tipsDialogShow.value = true
  } else if (inviteCode && !bindedCode.value) {
    // 通过扫码进来的会带有邀请码参数，直接弹出绑定对话框
    code.value = inviteCode
    bindDialogShow.value = true
  }
}
// 跳转到老用户界面
function toOldUser() {
  $router.replace({ name: 'activity-old-bring-new-old-user' })
}
// 确认绑定
async function confirmBindHandle() {
  if (!code.value) {
    showNormalToast('请输入邀请码')
    return
  }
  showToastLoading()
  try {
    await bindInvitationCode({
      invite_code: code.value,
      activity_guid: store?.state?.OldBringsNew?.activityGuid || '',
    })

    // 直接更新 store 中的 bindInviteCode
    store.commit('OldBringsNew/setUserInfo', { bindInviteCode: code.value })
    bindDialogShow.value = false
    showNormalToast('绑定邀请码成功')
  } catch (error) {
    commonErrorHandle(error)
  }
}
initActivityUserInfo()

onMounted(() => {
  setMiniProgramShareInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "邀请好友，奖励赚不停" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ActivityIntroduceImage)
    ]),
    _createVNode(CheckBindSn, {
      show: showCheckBindSn.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showCheckBindSn).value = $event))
    }, null, 8, ["show"]),
    _createElementVNode("div", { class: "footer-wrap em-container" }, [
      _createElementVNode("div", {
        class: "btn",
        onClick: startBindHandle
      })
    ]),
    _createVNode(ActivityDialog, {
      show: tipsDialogShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((tipsDialogShow).value = $event)),
      notedText: "点击跳转",
      onNotedTextClick: toOldUser
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(tipsContent.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ActivityDialog, {
      show: bindDialogShow.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((bindDialogShow).value = $event)),
      needConfirm: "",
      onConfirm: confirmBindHandle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(InputWrapItem, {
            class: "input-code",
            value: code.value,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event)),
            placeholder: "请输入邀请码"
          }, null, 8, ["value"]),
          _hoisted_7
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})